import { storeWrapper } from '../storeWrapper'
import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'

const initialState = {
  clientPortalData: {},
  clientNo: null
}

export const useClientPortalStore = storeWrapper('useClientPortalStore', (set) => ({
  ...initialState,
  fetchClientPortalData: async ({ clientNo }) => {
    return new Promise((resolve) => {
      debounce({
        id: `fetchClientPortalData_${clientNo}`,
        delay: 500,
        callback: async () => {
          let fetchedClientPortalData

          try {
            fetchedClientPortalData =
              (await ospreyAPI({
                service: 'matters',
                endpoint: 'ClientPortalClient/GetNamedClientsAndAssociates',
                data: { clientNo: clientNo }
              })) || {}
          } catch (err) {
            console.log('Error:', err)
            return
          }

          set({ clientPortalData: fetchedClientPortalData })
          resolve(fetchedClientPortalData)
        }
      })
    })
  },
  reset: () => set(initialState)
}))
